/**
 * Stacked employee name display.
 *
 * Backend stores an employee's Arabic name in `name` (always required) and
 * the English transliteration in `name_en` (optional). Every list/table
 * across the admin app must render them stacked — Arabic on top, English
 * below in a smaller muted line — so identifying employees is unambiguous.
 *
 * Pass `badgeData` (an object with `is_doctor / doctor_type / employment_type
 * / is_contracted_worker`) to display a classification badge inline next to
 * the name — used in Attendance, Qiwa, Payroll, etc. so the admin can spot
 * doctors / flexible / contracted staff at a glance.
 */
import { EmployeeTypeBadge } from './EmployeeTypeBadge';

export const EmployeeName = ({ name, nameEn, badgeData = null, badgeLanguage = 'ar', extra = null, className = '', testid }) => {
  if (!name && !nameEn) return <span className="text-[#655dc6]/40">-</span>;
  return (
    <div className={`leading-tight ${className}`} data-testid={testid}>
      <div className="flex items-center gap-1.5 flex-wrap">
        <span className="text-[#655dc6] font-medium">{name || '-'}</span>
        {badgeData && <EmployeeTypeBadge employee={badgeData} language={badgeLanguage} />}
      </div>
      {nameEn && (
        <div className="text-[10px] text-[#655dc6]/60 mt-0.5" dir="ltr">{nameEn}</div>
      )}
      {extra}
    </div>
  );
};

export default EmployeeName;
